var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOffer9Ball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,6A18,18 0,1 0,24,42A18,18 0,1 0,24,6",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8A16,16 0,1 0,24,40A16,16 0,1 0,24,8",
    fill: "#FFD000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,16A7.2,7.2 0,1 0,24,30.4A7.2,7.2 0,1 0,24,16",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7,27.5h-2.7v-2.8c-2.6,-0.2 -4.1,-1.6 -4.1,-4c0,-2.5 1.8,-4.1 4.7,-4.1c3.1,0 4.9,1.9 4.9,5.3c0,3.5 -1.9,5.6 -5.4,5.7v-2.3c1.6,-0.1 2.6,-0.8 2.9,-2c-0.8,0.4 -1.5,0.6 -2.4,0.6c-2.2,0 -3.8,-1.3 -3.8,-3.4c0,-1.8 1.3,-3.1 3.2,-3.1c1.9,0 3.2,1.3 3.2,3.3c0,0.5 -0.1,1.1 -0.4,1.8c0.8,-0.5 1.1,-1.2 1.1,-2.4c0,-1.9 -1,-3.1 -2.8,-3.1c-1.6,0 -2.6,0.8 -2.6,2.1c0,1.1 0.8,1.8 2.1,1.8c0.8,0 1.4,-0.2 2,-0.7l2.1,1.3z",
    fill: "#0D0D12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOffer9Ball);
export default __webpack_public_path__ + "static/media/p4r_business_offer_9ball.60c40e93b43035155e125ca848f01cd3.svg";
export { ForwardRef as ReactComponent };